const API_URL = "https://miblog-spring-react-mysql.herokuapp.com";

export const LOGIN_ENDPOINT = API_URL + "/users/login";
export const REGISTER_ENDPOINT = API_URL + "/users";
export const PUBLIC_POSTS_ENDPOINT = API_URL + "/posts/last";
export const POST_DETAILS_ENDPOINT = API_URL + "/posts";
export const USER_POSTS_ENDPOINT = API_URL + "/users/posts";
export const CREATE_POST_ENDPOINT = API_URL + "/posts";
export const DELETE_POST_ENDPOINT = API_URL + "/posts";
export const UPDATE_POST_ENDPOINT = API_URL + "/posts";